// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
$(document).on("turbo:load", () => $("#memo_import_user_id").select2({placeholder: "経過(メモ)インポートユーザー", allowClear: false}));
